module.exports = __webpack_public_path__ + "media/images/home/power_plate-70cda6f4ca757d68bdb20f9635573474.jpg";